//我的发票
import request from '../utils/request';
//获取发票记录列表
export function toEOrderInvoiceList(data) {
  return request({
    url: '/wap/invoice/toEOrderInvoiceList.do',
    method: 'post',
    data
  });
}
//获取申请发票列表
export function toOrderList(data) {
  return request({
    url: '/wap/invoice/toOrderList.do',
    method: 'post',
    data
  })
}
//获取申请发票
export function toGenerateInvoice(data) {
  return request({
    url: '/wap/invoice/doGenerateInvoiceNew.do',
    method: 'post',
    data
  })
}
// //获取申请发票
// export function toGenerateInvoice(data) {
//   return request({
//     url: '/wap/invoice/toGenerateInvoice.do',
//     method: 'post',
//     data
//   })
// }
//获取发票
export function toEOrderInvoiceDetail(data) {
  return request({
    url: '/wap/invoice/toEOrderInvoiceDetail.do',
    method: 'get',
    params: data
  });
}